// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1UOcF","author":"Table_author__3CATl","authorImage":"Table_authorImage__2TFQd","unreadRow":"Table_unreadRow__3oC_v"};